import { Icon } from "@/components/Icon";
import { cn, createBEM } from "@/libs";
import { Popover, Button } from "antd-mobile";
import { Action } from "antd-mobile/es/components/popover";
import { isEqual } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import './PopoverFilters.scss';
export type PopoverFilterType = {
  text: string;
  value: string;
};
export type PopoverFiltersProps = {
  items: PopoverFilterType[];
  onChange?: (value: string, node: PopoverFilterType) => void;
  value?: string;
  defaultValue?: string;
};
export const PopoverFilters = ({
  value,
  onChange,
  items,
  defaultValue
}: PopoverFiltersProps) => {
  const b = createBEM("i-popover-filter");
  const containerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [state, setState] = useState<string>(defaultValue || '');
  useEffect(() => {
    if (!isEqual(value, state)) {
      setState(value || '');
    }
  }, [value]);
  const actions = useMemo(() => {
    return items.map(item => ({
      key: item.value,
      text: item.text
    }));
  }, [items]);
  const text = useMemo(() => {
    const item = items.find(item => item.value === state);
    return item && item.text || '';
  }, [items, state]);
  const onActionChange = (node: Action) => {
    setOpen(false);
    const item = items.find(item => item.value === node.key);
    setState(item?.value || '');
    item && typeof onChange === 'function' && onChange(item.value, item);
  };
  return <div ref={containerRef} className={cn(b())} data-sentry-component="PopoverFilters" data-sentry-source-file="PopoverFilters.tsx">
    {open ? <div className={cn(b('blank'))} onClick={() => setOpen(false)}></div> : null}
    <Popover.Menu actions={actions} onAction={onActionChange} visible={open} placement="bottom" className={cn(b('body'))} getContainer={() => containerRef.current || document.body} data-sentry-element="unknown" data-sentry-source-file="PopoverFilters.tsx">
      <Button fill="none" onClick={() => {
        setOpen(true);
      }} data-sentry-element="Button" data-sentry-source-file="PopoverFilters.tsx">
        <span style={{
          display: "inline-block"
        }}>
          {text}
        </span>
        <Icon name={open ? "sort" : "sort-active"} size={"16px"} data-sentry-element="Icon" data-sentry-source-file="PopoverFilters.tsx" />
      </Button>
    </Popover.Menu>
  </div>;
};